/** @jsxImportSource @emotion/react */
import React from 'react';
import zoomControlsStyles from './ZoomControls.styles';
import { IconAddPlus } from '../../assets/icons/icon-add-plus';
import { IconRemoveMinus } from '../../assets/icons/icon-remove-minus';
import { useMap } from 'react-leaflet';

export const ZoomControls = () => {
    const map = useMap();

    const handleZoomIn = () => {
        map.zoomIn();
    };

    const handleZoomOut = () => {
        map.zoomOut();
    };

    return (
        <div css={zoomControlsStyles.container}>
            <div css={zoomControlsStyles.btnContainerTop} onClick={handleZoomIn}>
                <IconAddPlus size={20} color="#004FC6" />
            </div>

            <div css={zoomControlsStyles.btnContainerBottom} onClick={handleZoomOut}>
                <IconRemoveMinus size={20} color="#004FC6" />
            </div>
        </div>
    );
};
